import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { verifyGaCode } from "../../actions/setting-action";
import { connect, useDispatch } from "react-redux";
import useInput from "../hooks/useInput";
import Loading from "./Loading";
import { toast } from "react-toastify";
import { GA_CONFIRM, SIGN_OUT } from "../../actions/types";
import { useHistory, useLocation } from "react-router";
import "./GAPage.scss";

const GAPage = (props) => {
  const { verifyGaCode } = props;
  const [code, , , setCode] = useInput("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const pathname = (location.state && location.state.from) || "/dashboard";

  const handleCodeChange = (e) => {
    setCode(e.target.value.replace(/\D/g, "").slice(0, 6));
  };

  const clickConfirm = (e) => {
    e.preventDefault();
    if (code.length < 6) {
      toast.error("Enter the 6-digit authenticator code.");
      return;
    }

    setLoading(true);
    verifyGaCode(code)
      .then(() => {
        setLoading(false);
        dispatch({
          type: GA_CONFIRM,
        });
        history.push(pathname);
      })
      .catch(() => {
        toast.error("Code is invalid");
        setLoading(false);
      });
  };

  const signout = () => {
    dispatch({
      type: SIGN_OUT,
    });
  };
  return (
    <Loading show={loading} onHide={() => setLoading(false)}>
      <main className="ga-page">
        <div className="ga-page__orb ga-page__orb--blue" />
        <div className="ga-page__orb ga-page__orb--green" />
        <section className="ga-page__shell">
          <div className="ga-page__card">
            <a href="/" className="ga-page__brand">
              <img src="/images/new-stock-logo.svg" alt="StockHero" />
              <span>StockHero</span>
            </a>
            <div className="ga-page__icon">
              <i className="fa-solid fa-shield-halved" />
            </div>
            <span className="ga-page__eyebrow">Secure verification</span>
            <h1>Enter your authenticator code</h1>
            <p className="ga-page__copy">
              Open Google Authenticator on your phone and enter the 6-digit code
              to continue to your StockHero account.
            </p>

            <Form className="ga-page__form" onSubmit={clickConfirm}>
              <Form.Group controlId="google-auth-code">
                <Form.Label>Authenticator code</Form.Label>
                <div className="ga-page__code-field">
                  <i className="fa-solid fa-lock" />
                  <Form.Control
                    autoFocus
                    autoComplete="one-time-code"
                    inputMode="numeric"
                    maxLength={6}
                    placeholder="000000"
                    value={code}
                    onChange={handleCodeChange}
                  />
                </div>
              </Form.Group>
              <Button
                className="ga-page__confirm"
                type="submit"
                disabled={loading || code.length < 6}
              >
                Confirm and continue
              </Button>
            </Form>

            <button className="ga-page__switch-account" type="button" onClick={signout}>
              Login to another account
            </button>
          </div>
        </section>
      </main>
    </Loading>
  );
};

export default connect(null, { verifyGaCode })(GAPage);
